/* eslint-disable react/no-array-index-key */
import { Card, Col, Form, Row, Select } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, Card as CardStrap, CardBody, CardFooter, CardHeader } from 'reactstrap/lib';
import PropTypes from 'prop-types';
import _ from 'lodash';
import QuestionHeader from '../QuestionHeader';
import AudioButton from '../AudioButton';
import SubmitButton from '../SubmitButton';

const SelectWordInImage = ({ data, onSubmit, userData, questionIndex = 0 }) => {
  const numberOptions = data.answers.map((item) => {
    return { label: item.answer, value: item.answer };
  });

  const [form] = Form.useForm();

  const [suffledAnswers, setSuffledAnswers] = useState([]);
  useEffect(() => {
    if (userData) {
      const array = userData;
      setSuffledAnswers(array.answers);
      // Mục đích: Gán giá trị người dùng tới Select.
      let values = array.answers.map((item, index) => [index, item.userAnswer]); // Tạo mảng với 2 tham số là key và value. [key, value]
      values = Object.fromEntries(values); // Chuyển mảng vừa tạo thành đối tượng.{key: value}
      form.setFieldsValue(values); // Gán giá trị cho các trường.
      // Link tham khảo: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
    } else {
      const array = _.shuffle(data.answers);
      setSuffledAnswers(array);
    }
    return () => {
      setSuffledAnswers([]);
    };
  }, [data.answers, form, userData]);

  const renderQuestion = () => {
    const answers = suffledAnswers.map((item, index) => (
      <Col key={index}>
        <div style={{ textAlign: 'center' }}>
          <img alt='' style={{ height: 200 }} src={item.imageUrl} />
          <div className='mb-4' />
          <Form.Item name={`${index}`}>
            <Select options={numberOptions} style={{ border: '1px solid gray', borderRadius: 5, minWidth: 40, width: 'auto', fontSize: 20, fontWeight: 600 }} size='large' showArrow={false} />
          </Form.Item>
        </div>
      </Col>
    ));
    return <Fragment>{answers}</Fragment>;
  };

  return (
    <CardStrap>
      <CardHeader>
        <QuestionHeader title={data.title} subTitle={data.subTitle} questionIndex={questionIndex} tooltip='SelectWordInImage' />
      </CardHeader>

      <CardBody style={{ minHeight: 300 }}>
        <AudioButton audioUrl={data.audioUrl} />
        <Form form={form}>
          <Row gutter={[24, 0]}>{renderQuestion()}</Row>
        </Form>
      </CardBody>

      <CardFooter>
        <SubmitButton
          onClick={() => {
            const answers = suffledAnswers.map((item, index) => {
              const userAnswer = form.getFieldValue()[index];
              const isCorrect = item.answer === userAnswer;
              return { ...item, userAnswer, isCorrect };
            });
            const result = !answers.some((x) => x.isCorrect === false);
            // TODO: Cần có 2 tham số answers, result
            if (onSubmit && typeof onSubmit === 'function') onSubmit({ answers, result });
          }}
        />
      </CardFooter>
    </CardStrap>
  );
};

SelectWordInImage.propTypes = {
  data: PropTypes.object.isRequired,
  onSubmit: PropTypes.func,
  userData: PropTypes.array,
  questionIndex: PropTypes.number,
};

SelectWordInImage.defaultProps = {
  onSubmit: null,
  userData: null,
  questionIndex: 0,
};

export default SelectWordInImage;
